import { useFlags } from 'launchdarkly-react-client-sdk';

import { HiddenDebugMenu } from './HiddenDebugMenu';

/** Renders the hidden debug menu if allowed. Menu is hidden by default. */
export const DebugMenuGate = () => {
  const isAllowed = useFlags().hiddenDebugMenu; // User-specific LaunchDarkly flag

  return isAllowed ? <HiddenDebugMenu /> : null;
};
